var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, EventEmitter, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { KtsMultiSelectPartnerCompanyService, List } from './multiselect-partner-company.service';
import { ValidationService } from '../../../../service/validation.service';
import { AddRowDirective } from '../../../../component/addrow/addrow.directive';
var KtsMultiSelectPartnerCompanyComponent = /** @class */ (function (_super) {
    __extends(KtsMultiSelectPartnerCompanyComponent, _super);
    function KtsMultiSelectPartnerCompanyComponent(router, route, logger, action, message, page, service, validService) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.validService = validService;
        _this.modalSubmit = new EventEmitter();
        _this.recs = [];
        _this.items = [];
        _this.select = [];
        _this.addRec = {};
        _this.readonly = false;
        _this.excludeHq = false;
        _this.companyName = '';
        _this.constClassId = 0;
        _this.constClass = [];
        _this.constMiddleClassId = 0;
        _this.constMiddleClass = {};
        _this.areaId = 0;
        _this.area = [];
        _this.targetIds = [];
        _this.service.init();
        return _this;
    }
    KtsMultiSelectPartnerCompanyComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.excludeHq = jsonpath.value(this.component, '$.params.excludeHq') || false;
        this.subsc = this.service.observable.subscribe(function (flg) {
            if (flg) {
                _this.addError();
            }
        });
        if (this.cols.length > 0) {
            if (!this.cols[0].readonly) {
                this.getType();
                this.getList();
            }
            if (this.cols[0].readonly) {
                this.readonly = true;
            }
            if (this.cols[0].items) {
                this.getAddCols(this.cols[0].items);
            }
        }
        this.setCompRec();
    };
    KtsMultiSelectPartnerCompanyComponent.prototype.getType = function () {
        var _this = this;
        this.service.setBaseUrl('/v1/gen/construction-classification-m-api?query={"orderByList":[{"name":"id","direction":"asc"}]}');
        this.service.getRecord().subscribe(function (rec) {
            var constClass = [];
            var constMiddleClass = {};
            for (var _i = 0, _a = rec.items; _i < _a.length; _i++) {
                var item = _a[_i];
                constClass.push({ code: item.id, display: item.name });
                var options = [];
                _this.service.sortItems(item.construction_middle_classification, 'id');
                for (var _b = 0, _c = item.construction_middle_classification; _b < _c.length; _b++) {
                    var middleItem = _c[_b];
                    options.push({ code: middleItem.id, display: middleItem.name });
                }
                constMiddleClass[item.id] = options;
            }
            _this.constClass = constClass;
            _this.constMiddleClass = constMiddleClass;
        });
        this.service.getType('PARTNER_COMPANY_AREA').subscribe(function (rec) { return _this.area = rec; });
    };
    KtsMultiSelectPartnerCompanyComponent.prototype.getList = function () {
        var _this = this;
        this.recs = [];
        var url = '/v1/gen/partner-company-m-service';
        if (this.excludeHq) {
            url += '?query={"predicateList":[{"name":"unit_m.name","value":"hq","operator":"ne"}],"orderByList":[{"name":"id","direction":"asc"}]}';
        }
        else {
            url += '?query={"orderByList":[{"name":"id","direction":"asc"}]}';
        }
        this.service.setBaseUrl(url);
        this.service.getRecord().subscribe(function (rec) {
            _this.recs = rec.items || [];
        });
    };
    KtsMultiSelectPartnerCompanyComponent.prototype.getAddCols = function (cols) {
        this.addRec = {};
        for (var _i = 0, cols_1 = cols; _i < cols_1.length; _i++) {
            var col = cols_1[_i];
            if (col.hidden && col.key && col.params && typeof col.params.initValue !== 'undefined') {
                this.addRec[col.key] = col.params.initValue;
            }
        }
    };
    KtsMultiSelectPartnerCompanyComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.modal = this.remodalElement.nativeElement;
        this.remodal = $(this.modal).remodal({ hashTracking: false });
        var self = this;
        this.element = this.multiSelectElement.nativeElement;
        this.select = [];
        $(this.element).multiSelect({
            afterInit: function (ms) {
                var selectableSearchString = '#' + this.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';
                $(selectableSearchString).hide();
                if (self.constClassId || self.constMiddleClassId || self.areaId || self.companyName) {
                    for (var _i = 0, _a = self.targetIds; _i < _a.length; _i++) {
                        var target = _a[_i];
                        $(selectableSearchString + '[data-id="' + target + '"]').show();
                    }
                }
                else {
                    $(selectableSearchString).show();
                }
            },
            afterSelect: function (values) {
                if (values && values[0]) {
                    self.select.push(values[0]);
                }
            },
            afterDeselect: function (values) {
                if (values && values[0]) {
                    var idx = self.select.indexOf(values[0]);
                    if (idx >= 0) {
                        self.select.splice(idx, 1);
                    }
                }
                $(self.element).multiSelect('refresh');
            }
        });
        this.multiSelectOptions.changes.subscribe(function (t) {
            $(_this.element).multiSelect('refresh');
        });
    };
    KtsMultiSelectPartnerCompanyComponent.prototype.setUnsubscribe = function () {
        this.changeSubscription.unsubscribe();
    };
    KtsMultiSelectPartnerCompanyComponent.prototype.onSubscribe = function (data) {
        this.select = [];
        this.items = [];
        if (typeof data[this.cols[0].key] !== 'undefined' && data[this.cols[0].key] instanceof Array) {
            this.items = data[this.cols[0].key];
        }
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var item = _a[_i];
            if (typeof item.id !== 'undefined') {
                item.$type = "put" /* Put */;
            }
            this.select.push(item.partner_company_m_id.toString());
        }
        this.onCancel();
        this.setCompRec();
    };
    KtsMultiSelectPartnerCompanyComponent.prototype.onModeSubscribe = function (mode) {
        this.readonly = false;
        if (mode === 'confirm' || (this.cols.length > 0 && this.cols[0].readonly)) {
            this.readonly = true;
        }
    };
    KtsMultiSelectPartnerCompanyComponent.prototype.onEventSubscribe = function (e) {
        if (e === this.componentName + '#open') {
            this.onCancel();
            this.remodal.open();
        }
    };
    KtsMultiSelectPartnerCompanyComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    KtsMultiSelectPartnerCompanyComponent.prototype.onChangeName = function (e) {
        this.companyName = e.target.value;
    };
    KtsMultiSelectPartnerCompanyComponent.prototype.onChange = function (e, key) {
        var _this = this;
        var pred = [];
        if (key === 'constClass') {
            this.constClassId = parseInt(e.target.value);
            this.constMiddleClassId = 0;
        }
        else if (key === 'constMiddleClass') {
            this.constMiddleClassId = parseInt(e.target.value);
        }
        else if (key === 'area') {
            this.areaId = parseInt(e.target.value);
        }
        if (this.constMiddleClassId) {
            pred.push('{"operator":"eq","name":"link_partner_company_m_middle_classification.construction_middle_classification.id","value":"' + this.constMiddleClassId + '"}');
        }
        else if (this.constClassId) {
            pred.push('{"operator":"eq","name":"link_partner_company_m_middle_classification.construction_middle_classification.construction_classification_m.id","value":"' + this.constClassId + '"}');
        }
        if (this.areaId) {
            pred.push('{"operator":"in","name":"area_ids","values":["' + this.areaId + '"]}');
        }
        if (this.companyName) {
            pred.push('{"operator":"like","name":"name","value":"' + this.companyName + '"}');
        }
        if (pred.length === 0) {
            this.targetIds = [];
            $(this.element).multiSelect('refresh');
            return;
        }
        this.service.setBaseUrl('/v1/gen/partner-company-m-service?query={"predicateList":[' + pred.join(',') + ']}');
        this.service.getRecord().subscribe(function (rec) {
            var targets = [];
            for (var _i = 0, _a = rec.items; _i < _a.length; _i++) {
                var item = _a[_i];
                targets.push(item.id);
            }
            _this.targetIds = targets;
            $(_this.element).multiSelect('refresh');
        });
    };
    KtsMultiSelectPartnerCompanyComponent.prototype.onCancel = function () {
        this.companyName = '';
        $(this.element).multiSelect('deselect_all');
        var select = [];
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var item = _a[_i];
            if (item.$type !== "delete" /* Delete */) {
                select.push(item.partner_company_m_id.toString());
            }
        }
        $(this.element).multiSelect('select', select);
        this.select = select;
        this.constClassId = 0;
        this.constMiddleClassId = 0;
        this.areaId = 0;
        this.targetIds = [];
        $(this.element).multiSelect('refresh');
    };
    KtsMultiSelectPartnerCompanyComponent.prototype.onSubmit = function () {
        this.companyName = '';
        this.setItems();
        this.addError();
        this.setCompRec();
        this.remodal.close();
    };
    KtsMultiSelectPartnerCompanyComponent.prototype.setItems = function () {
        var items = JSOG.parse(JSON.stringify(this.items));
        for (var i = items.length - 1; i >= 0; i--) {
            if (typeof items[i].id === 'undefined') {
                items.splice(i, 1);
            }
            else {
                items[i].$type = "delete" /* Delete */;
            }
        }
        for (var _i = 0, _a = this.select; _i < _a.length; _i++) {
            var s = _a[_i];
            var rec = new List();
            for (var _b = 0, _c = this.recs; _b < _c.length; _b++) {
                var r = _c[_b];
                if (s === r.id.toString()) {
                    rec = r;
                    break;
                }
            }
            var add = true;
            for (var _d = 0, items_1 = items; _d < items_1.length; _d++) {
                var item = items_1[_d];
                if (item.partner_company_m_id === rec.id) {
                    add = false;
                    item.$type = "put" /* Put */;
                }
            }
            if (add) {
                items.push({
                    $type: "post" /* Post */,
                    partner_company_m_id: rec.id,
                    partner_company_name: rec.name
                });
            }
        }
        this.items = items;
    };
    KtsMultiSelectPartnerCompanyComponent.prototype.setCompRec = function () {
        var data = {};
        var items = JSOG.parse(JSON.stringify(this.items));
        if (Object.keys(this.addRec).length > 0) {
            for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
                var item = items_2[_i];
                Object.assign(item, this.addRec);
            }
        }
        for (var _a = 0, items_3 = items; _a < items_3.length; _a++) {
            var item = items_3[_a];
            delete item.partner_company_name;
        }
        data[this.cols[0].key] = items;
        this.action.setCompRec(this.componentName, data);
    };
    KtsMultiSelectPartnerCompanyComponent.prototype.addError = function () {
        if (this.cols[0].required && this.dir) {
            var items = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                if (item.$type === "delete" /* Delete */) {
                    continue;
                }
                items.push(item);
            }
            var errFlg = (items.length === 0 ? true : false);
            this.dir.addRequiredError(errFlg, this.msgSnapshot['ColumnComponent.error.required']);
            this.validService.afterValidation();
        }
    };
    KtsMultiSelectPartnerCompanyComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.subsc.unsubscribe();
        if ($(this.modal).parent().hasClass('remodal-wrapper')) {
            this.remodal.destroy();
        }
    };
    KtsMultiSelectPartnerCompanyComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-multiselect-partner-company',
                    template: "<form id=\"{{ componentName }}\" *ngIf=\"cols?.length > 0\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <dl class=\"form\">\n        <dt class=\"form_dt\">\n          <column-formtitle [key]=\"'form'\" [col]=\"cols[0]\" [msg]=\"(msg | async)\"></column-formtitle>\n        </dt>\n      </dl>\n    </div>\n  </div>\n  <div addrowDir></div>\n  <div class=\"row -mt-1\" *ngIf=\"!readonly\">\n    <div class=\"col-sm-12\">\n      <btn\n          [componentName]=\"componentName + '#Button'\"\n          [component]=\"{\n            params: {\n              buttons: [{\n                type: 'button',\n                event: componentName + '#open',\n                caption: (msg | async)['Button_select']\n              }]\n            }\n          }\"></btn>\n    </div>\n  </div>\n  <div class=\"row\" [class.-mt-1]=\"!readonly\">\n    <div class=\"col-sm-12\">\n      <div class=\"tableWrapper\" id=\"{{ componentName + '#List' }}\">\n        <table class=\"tableWrapper_table\">\n          <thead>\n          <tr data-href=\"#\">\n            <th><a class=\"-fixed\">{{ (msg | async)['au.COMPONENT.KtsMultiSelectPartnerCompanyComponent.label.partner_company_name'] }}</a></th>\n          </tr>\n          </thead>\n          <tbody>\n          <ng-template ngFor let-item [ngForOf]=\"items\">\n            <tr *ngIf=\"item.$type !== 'delete'\" data-href=\"#\">\n              <td>\n                <column-formlabel [col]=\"{}\" [val]=\"item.partner_company_name\"></column-formlabel>\n              </td>\n            </tr>\n          </ng-template>\n          </tbody>\n        </table>\n      </div>\n    </div>\n  </div>\n\n  <!-- remodal -->\n  <div class=\"remodal\" id=\"{{ componentName + '#MultiSelect' }}\" #remodal>\n    <div class=\"remodal_whitebg\">\n      <p *ngIf=\"component.title\" class=\"sectionHeading\">{{ component.title }}</p>\n      <div class=\"ms-container_divisionWrapper\">\n        <div class=\"row -mb-1\">\n          <div class=\"col-sm-6\"></div>\n          <div class=\"col-sm-4\">\n            <input type=\"text\" class=\"formInputText\" placeholder=\"{{(msg | async)['au.COMPONENT.KtsMultiSelectPartnerCompanyComponent.label.partner_company_name']}}\" [value]=\"companyName\" (change)=\"onChangeName($event)\">\n          </div>\n          <div class=\"col-sm-2\">\n            <item-btn [key]=\"'btn'\" [btn]=\"{\n              type: 'button',\n              event: componentName + '#search',\n              caption: (msg | async)['au.COMPONENT.KtsMultiSelectComponent.label.search']\n            }\" (click)=\"onChange($event, 'companyName')\"></item-btn>\n          </div>\n        </div>\n        <p class=\"ms-container_division\">\n          <select (change)=\"onChange($event,'constClass')\">\n            <option value=\"0\" [selected]=\"constClassId === 0\">{{ (msg | async)['au.COMPONENT.KtsMultiSelectPartnerCompanyComponent.select.constructionClassification'] }}</option>\n            <option *ngFor=\"let option of constClass\" [value]=\"option.code\" [selected]=\"constClassId.toString() === option.code\">{{ option.display }}</option>\n          </select>\n          <select (change)=\"onChange($event, 'constMiddleClass')\">\n            <option value=\"0\" [selected]=\"constMiddleClassId === 0\">{{ (msg | async)['au.COMPONENT.KtsMultiSelectPartnerCompanyComponent.select.constructionMiddleClassification'] }}</option>\n            <option *ngFor=\"let option of constMiddleClass[constClassId]\" [value]=\"option.code\" [selected]=\"constMiddleClassId.toString() === option.code\">{{ option.display }}</option>\n          </select>\n        </p>\n        <p class=\"ms-container_division\">\n          <select (change)=\"onChange($event, 'area')\">\n            <option value=\"0\" [selected]=\"areaId === 0\">{{ (msg | async)['au.COMPONENT.KtsMultiSelectPartnerCompanyComponent.select.area'] }}</option>\n            <option *ngFor=\"let option of area\" [value]=\"option.code\" [selected]=\"areaId.toString() === option.code\">{{ option.display }}</option>\n          </select>\n        </p>\n      </div>\n      <div class=\"ms-containerWrapper\">\n        <select multiple=\"multiple\" #multiSelect>\n          <option *ngFor=\"let option of recs\" [value]=\"option.id\" [attr.data-id]=\"option.id\" #multiSelectOptions>{{ option.name }}</option>\n        </select>\n      </div>\n    </div>\n    <div class=\"remodal_btns\">\n      <ul class=\"remodal_btns_group\">\n        <li>\n          <button type=\"submit\" class=\"remodal_btns_group-ok\" (click)=\"onSubmit()\">{{ (msg | async)['au.COMPONENTS.modal.button.decide'] }}</button>\n        </li>\n        <li>\n          <button data-remodal-action=\"cancel\" type=\"reset\" class=\"remodal_btns_group-cancel\" (click)=\"onCancel()\">{{ (msg | async)['au.COMPONENTS.modal.button.close'] }}</button>\n        </li>\n      </ul>\n    </div>\n  </div>\n  <!-- /remodal -->\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    KtsMultiSelectPartnerCompanyComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: KtsMultiSelectPartnerCompanyService },
        { type: ValidationService }
    ]; };
    KtsMultiSelectPartnerCompanyComponent.propDecorators = {
        modalSubmit: [{ type: Output }],
        remodalElement: [{ type: ViewChild, args: ['remodal',] }],
        multiSelectElement: [{ type: ViewChild, args: ['multiSelect',] }],
        multiSelectOptions: [{ type: ViewChildren, args: ['multiSelectOptions',] }],
        dir: [{ type: ViewChild, args: [AddRowDirective,] }]
    };
    return KtsMultiSelectPartnerCompanyComponent;
}(ContentBaseComponent));
export { KtsMultiSelectPartnerCompanyComponent };
//# sourceMappingURL=multiselect-partner-company.component.js.map